import { render, staticRenderFns } from "./PagePayeeInfoEdit.vue?vue&type=template&id=37e65992&"
import script from "./PagePayeeInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./PagePayeeInfoEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports